export default "__VITE_ASSET__DTr8pL6g__"